const ArticlePredefinedOptionType = {
  /**
   * There are 2 message where this is used.
   * 1. In article list navigation message
   * 2. In pre support prompt message when Explore articles is selected.
   */
  BROWSE_OTHER_ARTICLES: 'static.option.browser_other_articles',
  ISSUE_NOT_LISTED: 'static.option.issue_not_listed',
} as const;

const AlternativeActionsPredefinedOptionType = {
  RESTART_CHAT: 'static.action.restart_chat',
  END_CHAT: 'static.action.end_chat',
  CONNECT_TO_SUPPORT: 'static.action.connect_to_support',
} as const;
export const PredefinedOptionType = {
  ...ArticlePredefinedOptionType,
  ...AlternativeActionsPredefinedOptionType,
  POSITIVE_RESOLUTION: 'static.option.yes',
} as const;

export type PredefinedOptionKind = typeof PredefinedOptionType[keyof typeof PredefinedOptionType];
export type PredefinedArticleNavigationOptions = typeof ArticlePredefinedOptionType[keyof typeof ArticlePredefinedOptionType];
export type PredefinedAltActionOptions = typeof AlternativeActionsPredefinedOptionType[keyof typeof AlternativeActionsPredefinedOptionType];
export type PredefinedPreSupportOptions = PredefinedAltActionOptions | typeof PredefinedOptionType.BROWSE_OTHER_ARTICLES | typeof PredefinedOptionType.POSITIVE_RESOLUTION
